import { PlayerStore } from "@/features/player/model/store";
import React from "react";
import { PlayerStoreContext } from "@/features/player/model/context";

export const usePlayerStore = (): PlayerStore => {
    const store = React.useContext(PlayerStoreContext);
    if (!store) {
        throw new Error(
            "PlayerStore must be used within a PlayerStoreProvider",
        );
    }
    return store;
};
